module.exports = __webpack_public_path__ + "img/icone-invalidez-permanente-total-ou-parcial-por-acidente__primary-color.109bd184.png";